<div onsip-grid-placement-shelf>
  <div class="first-column">
    <section class="m-b-12">
      <div class="mat-body-1 semi-bold">
        {{ "ONSIP_I18N.MEMBERS" | translate }}({{ group.groupMemberAddresses.length }})
      </div>
    </section>
    @for (member of group.groupMemberAddresses; track member) {
    <section class="m-b-20" [attr.data-cy]="E2eLocators.ADMIN_GROUP_VIEW_SHELVE_MEMBER">
      <div>{{ member.address.name }}</div>
    </section>
    }
  </div>
</div>
<div class="page-view-controls">
  <button
    mat-flat-button
    color="primary"
    (click)="editPanel.emit()"
    [attr.data-cy]="E2eLocators.ADMIN_GROUP_VIEW_SHELVE_MEMBERS_EDIT"
  >
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
